import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img03.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#04396c" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Collaborate With Our Mobile App Developers In Ohio To Digitize
              Your Business{" "}
            </h2>
            <p>
              Are you ready to develop an app that sets a standard in the
              market? We have a team of skilled mobile app developers in Ohio
              who have a proven track record of bringing the best for the
              clients.{" "}
            </p>
            <p>
              We not only follow the guidelines given by our valuable clients
              but also suggest valuable inputs that can take your application to
              the next level of success. Hence, hire our professional mobile app
              developers in Ohio, and get the finest quality mobile application
              for your business.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#04396c",
                border: "1px solid #04396c",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
